module.exports = __webpack_public_path__ + "media/images/sp/top/recommend-plan-wedding4-d5ed49bc8806ab5b5fc259c0f6b35efd.jpg";